import * as React from 'react';
import {authorize} from "@athena-portal/components";
import {resourcesHelper} from "@falcon/services";
import FalconFooter from "../../../components/navigation/FalconFooter";
import FalconHeader from "../../../components/navigation/FalconHeader";
import {BackButton} from "../../../components/navigation/BackButton";
import {CollapseTextWidget} from "@falcon/plugin-falcon-journey";
import HowToVideoCollection from "../../../components/how-to-video/HowToVideoCollection";

interface IProps {
}

interface IState {
    product?: string,
    isLoading: boolean,
}

@authorize
export class HelpPage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isLoading: true,
            product: "",
        }
    }

    public async componentDidMount() {
        window.scrollTo(0, 0);
    }

    public render(): React.ReactNode {
        return <>
            <FalconHeader/>
            <div className="plugin">
                <BackButton isTop={true} link={"/dashboard/"}/>
                <div className="text-group title plugin no-indent-desktop">
                    <h1 className="mb-2 text-red-3">
                        <span>Help</span>
                    </h1>
                </div>
                <div>
                    <div>
                        <p>
                            We like to make things easy and save everyone time, so <strong>we only use the phones when
                            you need to make claim</strong>. Our online team are here for you if you have a question or
                            need some help.
                        </p>
                    </div>
                    <div className="mt-3 mb-0 lh-26">
                        <span>To use our live chat</span>
                        <span className="px-2">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M4.8 5H14.8C15.241 5 15.6 5.358 15.6 5.8C15.6 6.241 15.241 6.6 14.8 6.6H4.8C4.359 6.6 4 6.241 4 5.8C4 5.358 4.359 5 4.8 5ZM4.8 9H8.989C9.724 8.125 10.811 7.556 12.04 7.556H19.596C19.598 7.219 19.6 7.002 19.6 7.002V2.8C19.6 1.256 18.344 0 16.8 0H2.8C1.256 0 0 1.256 0 2.8V18.8C0 19.123 0.195 19.415 0.494 19.539C0.593 19.58 0.696 19.6 0.8 19.6C1.008 19.6 1.213 19.519 1.365 19.365L5.131 15.6H8V11.556C8 11.225 8.092 10.907 8.168 10.6H4.8C4.359 10.6 4 10.241 4 9.8C4 9.358 4.359 9 4.8 9ZM17.727 15.544C17.175 15.544 16.727 15.096 16.727 14.544C16.727 13.991 17.175 13.544 17.727 13.544C18.279 13.544 18.727 13.991 18.727 14.544C18.727 15.096 18.279 15.544 17.727 15.544ZM14.274 15.544C13.721 15.544 13.274 15.096 13.274 14.544C13.274 13.991 13.721 13.544 14.274 13.544C14.825 13.544 15.274 13.991 15.274 14.544C15.274 15.096 14.825 15.544 14.274 15.544ZM22 11.394C21.916 10.37 21.045 9.556 20 9.556H12C10.901 9.556 10 10.456 10 11.556V17.556C10 18.655 10.901 19.556 12 19.556H18.425L20.635 21.766C20.787 21.919 20.992 22 21.2 22C21.304 22 21.407 21.98 21.506 21.939C21.806 21.815 22 21.523 22 21.2C22 21.2 22.003 11.407 22 11.394Z"
                                      fill="#003781"/>
                            </svg>
                        </span>
                        <span>
                            please look out for this icon on the screen.
                        </span>
                    </div>
                    <div className="help-banner banner-content justify-content-around align-items-center px-5 fs-16">
                        <div
                            className="d-inline-flex align-items-center">
                            <span className="d-inline-flex">
                                <img src={`/${resourcesHelper.THEME}/img/britannia-no-phone.svg`} className="mr-3"
                                     alt={`No calls`}/>
                            </span>
                            <span className="d-inline-flex align-items-baseline flex-nowrap">
                            <strong>Manage your policy <br/> YOURSELF online</strong>
                            </span>
                        </div>
                        <div className="d-inline-flex align-items-center">
                            <span className="d-inline-flex">
                              <img src={`/${resourcesHelper.THEME}/img/britannia-headset-support.svg`} className="mr-3"
                                   alt={`Headset support`}/>
                            </span>
                            <span className="d-inline-flex align-items-baseline flex-nowrap">
                              <strong>Only call us to claim</strong>
                            </span>
                        </div>
                        <div className="d-inline-flex align-items-center">
                            <span className="d-inline-flex">
                               <img src={`/${resourcesHelper.THEME}/img/smartphone.svg`} className="mr-3"
                                    alt={`Smartphone`}/>
                            </span>
                            <span className="d-inline-flex align-items-baseline flex-nowrap">
                              <strong>Simple, digital, <br/> hassle-free</strong>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="mt-3 mb-4">
                    <p>We’ve answered your questions before you even thought of them! Head to our <strong><u><a
                        href="https://www.britanniainsurance.co.uk/car-insurance/faqs.html">FAQs</a></u></strong> section
                        to save yourself time.</p>
                </div>
                <div className="collapsible-questions">
                    <p className="font-family-base font-weight-semi-bold text-blue-2 fs-20">Most common
                        questions</p>
                    <CollapseTextWidget summary="How do I get in touch?" p={
                        <div className="collapsible-answers">
                            <h3>Chat to us</h3>
                            <p>How to access our Live Chat:</p>
                            <p>Click on the blue chat icon in the bottom right corner of your screen.</p>
                            <p>
                                If the chat button isn't visible, you may need to enable cookies. You can do this by
                                clicking the blue shield icon in the bottom left of your screen, then selecting 'Allow
                                All'
                                and 'Confirm My Choices'.
                            </p>
                            <p>Our Live Chat opening hours are:</p>
                            <p>
                                Monday to Friday 8am - 8pm<br/>
                                Saturday and bank holidays 9am - 5pm<br/>
                                Sunday 10am - 4pm</p>

                            <h3>Email us</h3>
                            <p>For anything outside of those hours, please email us at:
                                digitalhelp@britanniainsurance.co.uk.
                                <br/>
                                To help us find your policy, please include your full name, postcode, and vehicle
                                registration.</p>
                            <p>
                                Email replies can take up to 24 hours during busy periods.<br/>
                                Please don't email again if you are waiting for a reply, as this can delay us getting
                                back
                                to you and other customers.</p>
                        </div>
                    }/>
                    <CollapseTextWidget summary="Will I be covered to drive other cars with Britannia Insurance?" p={
                        <div className="collapsible-answers">
                            <p>
                                Yes. Britannia Car Insurance policyholders may have third party only cover for driving
                                other
                                cars, subject to certain restrictions. We recommend checking your certificate of motor
                                insurance in your account to confirm if you have this cover.
                            </p>
                            <p>
                                If applicable, this cover is for the policyholder only, not named drivers and is
                                restricted
                                to third party only cover in the UK, Isle of Man and the Channel Islands. The loss or
                                damage
                                to the vehicle you're driving isn't covered. Refer to your Document of Insurance for
                                further
                                information.
                            </p>
                        </div>
                    }/>
                    <CollapseTextWidget summary="Am I covered to drive in Europe?" p={
                        <div className="collapsible-answers">
                            Yes.
                            <p>
                                With our <strong>Britannia Premier</strong> cover level you'll have comprehensive cover
                                while driving your
                                car in Europe for up to <strong>180 days</strong> of the policy year.</p>

                            <p>Our <strong>Britannia</strong> cover level will provide comprehensive cover while driving
                                your car in Europe
                                for up to <strong>90 days</strong> of the policy year.</p>

                            <p>If you have our <strong>Britannia Essentials</strong> cover level, you'll have the
                                minimum compulsory cover
                                needed by law to drive a car in Europe for up to <strong>180 days</strong> of the policy
                                year.</p>
                        </div>
                    }/>
                </div>
                <div className="divider-line mt-3 mb-4"/>
                <HowToVideoCollection/>
                <BackButton isTop={false} link={"/dashboard/"}/>
            </div>
            <FalconFooter/>
        </>
    }
}
